'use client';

import * as React from 'react';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import BlurText from '../BlurText';
import { twMerge } from 'tailwind-merge';
import isDefinedAndNonNull from '@th/shared/src/utils/isDefinedAndNonNull';
import SvgIcon from '../icons/SvgIcon';

type Props = {
  listing: SimpleListing;
  isBlurred: boolean;
  includeSqft?: boolean;
  className?: string;
  textClassName?: string;
};

export default function ListingSpaceSummary({
  listing,
  isBlurred,
  includeSqft = true,
  className,
  textClassName = 'text-secondaryText',
}: Props) {
  return (
    <div className={twMerge('flex flex-row items-center space-x-4', className)}>
      {isDefinedAndNonNull(listing.bedroomsText()) && (
        <div className="flex items-center">
          <SvgIcon
            name={'FaSolidBed'}
            className={twMerge('h-4 w-4', textClassName)}
          />
          <p className={twMerge('ml-1.5 mb-0 mt-0', textClassName)}>
            <BlurText isBlurred={isBlurred}>{listing.bedroomsText()}</BlurText>
          </p>
        </div>
      )}
      {isDefinedAndNonNull(listing.bathroomsText()) && (
        <div className="flex items-center">
          <SvgIcon
            name={'FaSolidBath'}
            className={twMerge('h-4 w-4', textClassName)}
          />
          <p className={twMerge('ml-1.5 mb-0 mt-0', textClassName)}>
            <BlurText isBlurred={isBlurred}>{listing.bathroomsText()}</BlurText>
          </p>
        </div>
      )}
      {isDefinedAndNonNull(listing.garageText()) && (
        <div className="flex items-center">
          <SvgIcon
            name={'FaSolidCar'}
            className={twMerge('h-4 w-4', textClassName)}
          />
          <p className={twMerge('ml-1.5 mb-0 mt-0', textClassName)}>
            <BlurText isBlurred={isBlurred}>{listing.garageText()}</BlurText>
          </p>
        </div>
      )}
      {isDefinedAndNonNull(listing.sqftText()) && includeSqft && (
        <div className="flex items-center">
          <SvgIcon
            name={'FaSolidRulerCombined'}
            className={twMerge('h-4 w-4', textClassName)}
          />
          <p className={twMerge('ml-1.5 mb-0 mt-0', textClassName)}>
            <BlurText isBlurred={isBlurred}>
              {listing.sqftText().replace(' sqft', '')}
            </BlurText>
          </p>
        </div>
      )}
    </div>
  );
}
